module.exports = "/_next/static/images/cardImage2-1e015fd27c4fa25b536705a8e54aa734.webp";